(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fhq-home-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.FHQHomeMotion) {
      window.FHQHomeMotion.refresh(document);
      return;
    }

    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    let observer = null;

    const finish = (section) => {
      if (!section) return;
      section.classList.remove('fhq-motion-ready', 'fhq-motion-visible');
      if (section.fhqMotionCleanupTimer) window.clearTimeout(section.fhqMotionCleanupTimer);
      if (section.fhqMotionFailOpenTimer) window.clearTimeout(section.fhqMotionFailOpenTimer);
      section.fhqMotionCleanupTimer = null;
      section.fhqMotionFailOpenTimer = null;
    };

    const reveal = (section, immediate = false) => {
      if (!section) return;
      if (observer) observer.unobserve(section);
      if (section.fhqMotionCleanupTimer) window.clearTimeout(section.fhqMotionCleanupTimer);
      if (section.fhqMotionFailOpenTimer) window.clearTimeout(section.fhqMotionFailOpenTimer);

      if (immediate || motionQuery.matches || designMode) {
        finish(section);
        return;
      }

      /* Install the fail-open path before any class is allowed to hide content. */
      section.fhqMotionFailOpenTimer = window.setTimeout(() => finish(section), 2000);
      section.classList.add('fhq-motion-ready');

      window.requestAnimationFrame(() => {
        if (!section.isConnected) {
          finish(section);
          return;
        }

        section.classList.add('fhq-motion-visible');
        section.fhqMotionCleanupTimer = window.setTimeout(() => finish(section), 1300);
      });
    };

    if (!motionQuery.matches && !designMode && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          window.requestAnimationFrame(() => {
            if (entry.target.isConnected) reveal(entry.target);
          });
        });
      }, {
        threshold: 0,
        rootMargin: '0px 0px -7% 0px'
      });
    }

    const bind = (section) => {
      if (!section || section.dataset.fhqMotionBound === 'true') return;
      section.dataset.fhqMotionBound = 'true';

      if (motionQuery.matches || designMode || !observer) {
        reveal(section, true);
        return;
      }

      observer.observe(section);
    };

    const refresh = (root) => {
      const sections = [];
      if (root && root.matches && root.matches('[data-fhq-motion="true"]')) sections.push(root);
      if (root && root.querySelectorAll) {
        sections.push(...root.querySelectorAll('[data-fhq-motion="true"]'));
      }
      sections.forEach(bind);
    };

    const cleanup = (root) => {
      if (!root) return;
      const sections = [];
      if (root.matches && root.matches('[data-fhq-motion="true"]')) sections.push(root);
      if (root.querySelectorAll) {
        sections.push(...root.querySelectorAll('[data-fhq-motion="true"]'));
      }

      sections.forEach((section) => {
        if (observer) observer.unobserve(section);
        finish(section);
      });
    };

    const findMotionSection = (target) => {
      if (!target) return null;
      if (target.matches && target.matches('[data-fhq-motion="true"]')) return target;
      if (target.closest) {
        const ancestor = target.closest('[data-fhq-motion="true"]');
        if (ancestor) return ancestor;
      }
      if (target.querySelector) return target.querySelector('[data-fhq-motion="true"]');
      return null;
    };

    window.FHQHomeMotion = { refresh, reveal };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
    } else {
      refresh(document);
    }

    document.addEventListener('shopify:section:load', (event) => refresh(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanup(event.target));
    document.addEventListener('focusin', (event) => reveal(findMotionSection(event.target), true));
    document.addEventListener('shopify:section:select', (event) => reveal(findMotionSection(event.target), true));
    document.addEventListener('shopify:block:select', (event) => {
      reveal(findMotionSection(event.target), true);
    });

    const handleMotionChange = (event) => {
      if (!event.matches) return;
      document.querySelectorAll('[data-fhq-motion="true"]').forEach((section) => reveal(section, true));
    };

    if (typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', handleMotionChange);
    } else {
      motionQuery.addListener(handleMotionChange);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
